export interface SuperadminApiClient {
  readonly apiBase: string;
  readonly getAuthToken: () => Promise<string>;
}

let current: SuperadminApiClient = {
  apiBase: "",
  getAuthToken: async () => {
    throw new Error(
      "SuperadminApiClient.getAuthToken: not configured — host must call setSuperadminApi() at boot",
    );
  },
};

export function setSuperadminApi(client: SuperadminApiClient): void {
  current = client;
}

export function getSuperadminApi(): SuperadminApiClient {
  return current;
}

export function __resetSuperadminApi(): void {
  current = {
    apiBase: "",
    getAuthToken: async () => {
      throw new Error("not configured");
    },
  };
}
